<div class="grid">
    @for (zone of getPagedZones(); track zone) {
        @let promo = getSelectedPromo(zone);
        <div class="card">
            <div class="image">
                @if (zone.promos.length > 1) {
                    <button type="button"
                            class="carousel-preview-button"
                            (click)="openPreview(getSelectedPromo(zone))">
                        <mx-image-carousel
                                [images]="getThumbnailsForPromos(zone.promos)"
                                (selectedIndexChange)="onImageChange(zone.id, $event)">
                        </mx-image-carousel>
                    </button>

                } @else {
                    <button
                            type="button"
                            class="image-preview-button"
                            (click)="openPreview(promo)"
                    >
                        <mx-thumbnail
                                [defaultThumbnailClass]="this.getThumbnailClass(promo)"
                                [thumbnailUrl]="this.getThumbnailUrl(promo)">
                        </mx-thumbnail>
                    </button>
                }
            </div>


            <div class="info">
                <div class="header">
                    <div class="title">{{ promo.typeName }}</div>

                    <div class="header-right">
                        <div class="meta-badges">
                            <span class="badge badge-lang">{{ promo.languageCode }}</span>
                            <span class="badge badge-currency">{{ promo.currencyCode }}</span>
                        </div>

                        @if (hasDescription(zone, promo)) {
                            <button type="button"
                                    class="info-btn"
                                    #descTooltip="matTooltip"
                                    [matTooltip]="buildDescriptionTooltip(zone, promo)"
                                    matTooltipClass="prl-description-tooltip"
                                    matTooltipPosition="above"
                                    [matTooltipHideDelay]="4000"
                                    (click)="descTooltip.toggle()"
                                    [attr.aria-label]="zoneDescriptionLabel">
                                <mat-icon>info_outline</mat-icon>
                            </button>
                        }
                    </div>
                </div>

                <div class="meta">
                    <span class="icon arrows">↔</span>
                    {{ promo.subTypeName }}
                </div>

                <div class="category">
                    <mat-icon>category</mat-icon>
                    {{ promo.productName }}
                </div>

                <div class="btn-container">
                    <mx-button [buttonModel]="generateCodeBtn" (click)="generateCode(zone)"></mx-button>
                </div>
            </div>
        </div>
    }
</div>

<mx-pagination
        [dataSource]="dataSource"
        [updatePaginator]="lightZones?.length ?? 0"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        (pageChange)="pageSelected($event)">
</mx-pagination>